import React from "react";
import { Polygon } from "react-leaflet";
import { useDispatch, useSelector } from "react-redux";
import { setMapDialogData, setMapDialog } from "../../redux/actions/shared-actions";
import {
  getTramIcon,
  getTrolleyIcon,
  getBusIcon,
  createClusterTrolleyIcon,
  createClusterTramIcon,
  createClusterBusIcon,
} from "../../services/shared";
import MapClusterGroups from "./marker-cluster-groups";
import polylineColors from "../shared/map-polyline-colors";

/**
 * Component displaying the green corridors related data
 * Regions polygons are drawn
 * Polylines of and stops icon clusters for the lines which intersect the green corridors regions
 * @component
 * @category Components
 * @subcategory Map
 * @param {object} data the green corridors data
 */

const MapGreenCorridors = ({ data }) => {
  const dispatch = useDispatch();
  const defaultStyles = {
    color: polylineColors.corridors,
  };
  const highligth = {
    color: "#006633",
  };

  let corridorTrams = {};
  let corridorTrolleys = {};
  let corridorBuses = {};

  Object.values(data[1]).forEach((tram) => {
    if (data[0][0].tramLines.indexOf(tram.line) > -1) {
      corridorTrams[tram.vehicleId] = tram;
    }
  });
  Object.values(data[2]).forEach((trolley) => {
    if (data[0][0].trolleyLines.indexOf(trolley.line) > -1) {
      corridorTrolleys[trolley.vehicleId] = trolley;
    }
  });
  Object.values(data[3]).forEach((bus) => {
    if (data[0][0].busLines.indexOf(bus.line) > -1) {
      corridorBuses[bus.vehicleId] = bus;
    }
  });

  const dataUtils = [
    {
      id: "trams",
      iconCreater: createClusterTramIcon,
      iconGetter: getTramIcon,
      data: corridorTrams,
    },
    {
      id: "trolleys",
      iconCreater: createClusterTrolleyIcon,
      iconGetter: getTrolleyIcon,
      data: corridorTrolleys,
    },
    {
      id: "buses",
      iconCreater: createClusterBusIcon,
      iconGetter: getBusIcon,
      data: corridorBuses,
    },
  ];

  const handleCorridorHover = (e, polylineWeight, tramsLinesArray, trolleyLinesArray) => {
    const map = e.target._map;
    for (let layer in map._layers) {
      if (tramsLinesArray.indexOf(map._layers[layer].options.line) !== -1) {
        map._layers[layer].setStyle({ weight: map._layers[layer].options.weight + polylineWeight });
      }
      if (trolleyLinesArray.indexOf(map._layers[layer].options.line) !== -1) {
        map._layers[layer].setStyle({ weight: map._layers[layer].options.weight + polylineWeight });
      }
    }
    e.target.setStyle(defaultStyles);
  };

  const sortLinesString = (a, b) => {
    const [, lineNumberA] = a.match(/[a-zA-Z]+|[0-9]+/g);
    const [, lineNumberB] = b.match(/[a-zA-Z]+|[0-9]+/g);
    return lineNumberA - lineNumberB;
  };

  return (
    <React.Fragment>
      {data[0].map((polygon) => {
        return (
          <React.Fragment key={polygon.name}>
            <Polygon
              id={polygon.name}
              positions={polygon.coordinates}
              color={defaultStyles.color}
              weight={5}
              eventHandlers={{
                click: () => {
                  dispatch(setMapDialog(true));
                  dispatch(
                    setMapDialogData({
                      type: "greenCorridor",
                      id: polygon.id,
                      lines: [
                        ...polygon.tramLines.sort(sortLinesString),
                        ...polygon.trolleyLines.sort(sortLinesString),
                        ...polygon.busLines.sort(sortLinesString),
                      ],
                    })
                  );
                },
                mouseover: (e) => {
                  handleCorridorHover(e, 3, polygon.tramLines, polygon.trolleyLines);
                  e.target.setStyle(highligth);
                },
                mouseout: (e) => {
                  e.target.setStyle(defaultStyles);
                  handleCorridorHover(e, -3, polygon.tramLines, polygon.trolleyLines);
                },
              }}
            />

            {/* {TMData.filter((tramLine) => polygon.tramLines.indexOf(tramLine.line) !== -1).map((line) => {
              return (
                <React.Fragment key={line.line}>
                  <>
                    {mapZoom > 14 ? (
                      <>
                        {Object.values(line)
                          .filter((x) => typeof x !== "string")
                          .map((direction) => {
                            return (
                              <MapClusterGroups
                                key={direction.name + "-stops"}
                                data={direction.stops}
                                iconCreater={createClusterTramStopIcon}
                                iconGetter={getTramStopIcon}
                                stopData={{ line: line.line, direction: direction.name }}
                              />
                            );
                          })}
                      </>
                    ) : null}

                    {Object.values(line)
                      .filter((x) => typeof x !== "string")
                      .map((direction) => {
                        return (
                          <MapPolylines
                            key={direction.name + "-segments"}
                            data={direction.segments}
                            type={"trams"}
                            line={line.line}
                          />
                        );
                      })}
                  </>
                </React.Fragment>
              );
            })}
            {TBData.filter((trolleyLine) => polygon.trolleyLines.indexOf(trolleyLine.line) !== -1).map((line) => {
              return (
                <React.Fragment key={line.line}>
                  <>
                    {mapZoom > 14 ? (
                      <>
                        {Object.values(line)
                          .filter((x) => typeof x !== "string")
                          .map((direction) => {
                            return (
                              <MapClusterGroups
                                key={direction.name + "-stops"}
                                data={direction.stops}
                                iconCreater={createClusterTrolleyStopIcon}
                                iconGetter={getTrolleyStopIcon}
                                stopData={{ line: line.line, direction: direction.name }}
                              />
                            );
                          })}
                      </>
                    ) : null}

                    {Object.values(line)
                      .filter((x) => typeof x !== "string")
                      .map((direction) => {
                        return (
                          <MapPolylines
                            key={direction.name + "-segments"}
                            data={direction.segments}
                            type={"trolleys"}
                            line={line.line}
                          />
                        );
                      })}
                  </>
                </React.Fragment>
              );
            })} */}
          </React.Fragment>
        );
      })}

      {dataUtils.map((x) => {
        return (
          <MapClusterGroups
            key={data[0][0].id + "-" + x.id}
            data={x.data}
            iconCreater={x.iconCreater}
            iconGetter={x.iconGetter}
          />
        );
      })}
    </React.Fragment>
  );
};
export default React.memo(MapGreenCorridors);
